<template>
  <section class="serviceDetail">
    <header-com />
    <img
      src="/images/home/teamSuc.png"
      align="middle"
      class="suc"
      :class="{active:active}"
      v-if="detail.groupRecordStatus == 30 && isInCustomer"
    />
    <img
      src="/images/home/teamFal.png"
      align="middle"
      class="fal"
      :class="{active:active}"
      v-if="detail.groupRecordStatus == 40"
    />
    <div class="goodsDetail" @click="toService">
      <img :src="formatImgUrl(detail.curingServiceGoodsBo.pic,240,240,true)" align="middle" />
      <div>
        <div class="name" @click="toService">{{detail.curingServiceGoodsBo.name}}</div>
        <div class="dero">{{detail.curingServiceGoodsBo.content}}</div>
        <div class="price">￥{{detail.curingServicePrice}}</div>
      </div>
    </div>

    <div class="block"></div>
    <div class="teamDetail_content">
      <h3 v-if="detail.groupRecordStatus == 20">
        还差
        <span>{{detail.differMemberNum}}人</span>邀请成功
      </h3>
      <h3 v-if="detail.groupRecordStatus == 30 && isInCustomer">邀请成功</h3>
      <h3 v-if="detail.groupRecordStatus == 30 && !isInCustomer">人数已满</h3>
      <h3 v-if="detail.groupRecordStatus == 40">邀请失败</h3>
      <div class="time" v-if="detail.groupRecordStatus == 20">
        <div class="content_time">
          <span>距离拼团失效：</span>
          <count-down
            class="countDown"
            :startTime="new Date().getTime()"
            :endTime="endTime"
            v-on:end_callback="countDownE_cb(1)"
            :dayTxt="'天'"
            :hourTxt="':'"
            :minutesTxt="':'"
            :secondsTxt="''"
          ></count-down>
        </div>
      </div>

      <div class="user_img">
        <div style="width:70%">
          <van-row>
            <template v-for="(item,index) in detail.detailBOList">
              <van-col span="6">
                <div class="team_header" >
                  <img
                    v-if="item.headImgUrl"
                    :src="formatImgUrl(item.headImgUrl,160,160,true)"
                    align="middle"
                  />
                  <img v-else :src="DEFAULT_AVATAR" align="middle" />
                  <div class="title" v-if="item.memberRole == 20">团长</div>
                  <div class="customerName">{{item.customerName}}</div>
                </div>
              </van-col>
              <van-col span="3" v-if="index!=2">
                <div style="line-height: 60px;line-height: 60px;">
                <img
                  src="/images/growth/add-cion.png"
                  style="border:0;width:12px;height:12px"
                  align="middle"
                />
              </div>
              </van-col>
            </template>
            <template v-for="n in detail.differMemberNum" >
              <van-col span="6">
                <div class="wait_user" @click="shadowTrue()">?</div>
              </van-col>
              <van-col span="3" v-if="n + detail.detailBOList.length<3">
                <div style="line-height: 60px;line-height: 60px;">
                <img
                  src="/images/growth/add-cion.png"
                  style="border:0;width:12px;height:12px"
                  align="middle"
                />
              </div>
              </van-col>
            </template>
          </van-row>
        </div>
           
        
      </div>

      <div
        v-if="(detail.groupRecordStatus == 30 && !isInCustomer) || !showCantuan"
        class="newTeam"
      >{{message}}</div>

      <div class="btn_content mt64" v-if="detail.groupRecordStatus == 30 && !isInCustomer">
        <button class="primary mybtn" @click="startTeam">发起新的拼团</button>
      </div>

      <div
        class="btn_content mt64"
        v-if="detail.groupRecordStatus == 20 && customerIds.indexOf($store.state.customerId) == -1"
      >
        <button class="primary mybtn" @click="submit()">￥{{detail.curingServicePrice}} 立即参团</button>
      </div>

      <div
        class="btn_content mt64"
        :class="{mt16:customerIds.indexOf($store.state.customerId) == -1}"
        v-if="detail.groupRecordStatus == 20"
      >
        <button
          v-if="customerIds.indexOf($store.state.customerId) == -1"
          class="shareButton"
          @click="shadowTrue()"
        >
          <span>{{shareBtnText}}</span>
        </button>
        <button
          v-if="customerIds.indexOf($store.state.customerId) != -1"
          class="primary mybtn"
          @click="shadowTrue()"
        >
          <span>{{shareBtnText}}</span>
        </button>
      </div>

      <div
        class="btn_content mt64"
        v-if="detail.groupRecordStatus == 20&&customerIds.indexOf($store.state.customerId) != -1"
      >
        <button class="shareButton" @click="addKefyuWechat">加客服微信</button>
      </div>

      <div class="btn_content mt64" v-if="detail.groupRecordStatus == 30&&isInCustomer">
        <!-- <button v-if="!getGift.awardName" class="primary mybtn" @click="toGetGrowthShare()">选礼品（必选）</button> -->
        <button
          style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
          v-if="getGift.awardName"
          class="shareButton"
         
        >
          <span>你已获得{{getGift.awardName}}奖品</span>
        </button>
      </div>

      <div class="btn_content mt16" v-if="(detail.groupRecordStatus == 30 && isInCustomer)">
        <button class="primary mybtn" @click="toSendBag()">去养护</button>
      </div>
      <div class="btn_content mt64" v-if="(detail.groupRecordStatus == 30 && isInCustomer)">
        <button class="shareButton" @click="lookOrder()">查看优惠券</button>
      </div>
      <div class="btn_content mt64" v-if="detail.groupRecordStatus == 40">
        <button class="primary mybtn" @click="lookMore()">查看更多</button>
      </div>
    </div>
    <div class="rule_content">
      <div class="contentItem">
        <div>
          <img style="width:100%" src="/images/growth/sucss.png" />
        </div>
        <div>
          <div class="title-dis">只需3步礼品轻松带走</div>
          <div class="pic-body">
            <div style="padding: 0px 20px;line-height: 25px;font-size: 14px;">
              <div>第1步 <span  style="color:#009576">发起或参加拼团</span></div>
              <div style="margin-left:40px">拼150元代金券+恶搞包领取资格</div>
              <div>第2步 <span  style="color:#009576">成团后，给你的宝贝做个养护</span></div>
              <div style="margin-left:40px">一定要成团后再下单养护</div>
              <div>第3步 <span  style="color:#009576">获得礼品！</span></div>
              <div style="margin-left:40px">恶搞包随养护完成的宝贝一起寄回</div>
            </div>
            <!-- <img style="width:100%" src="/images/growth/dis-gee.png" /> -->
            <div
              class="utoon-dis"
              style="margin:30px 0"
              v-if="detail.groupRecordStatus == 20 && showKaituanFlag"
            >
              <button class="primary mybtn" @click="submit()">￥{{detail.curingServicePrice}} 立即参团</button>
            </div>
          </div>
        </div>
        <div>
          <div style="width:100%;height:20px"></div>
          <div class="title-dis">加客服微信 锁定礼品资格</div>
          <div style="text-align: center;">
            <button class="shareButton" @click="addKefyuWechat">加客服微信</button>
          </div>
        </div>
        <div style="width:100%;height:50px"></div>
        <!-- <div v-if="item.blockContent" v-html="item.blockContent" class="blockContent"></div> -->
      </div>
    </div>
    <div class="block"></div>
    <div class="rule_content1">
      <div
        class="contentItem"
        v-for="(item, index) in serviceIntroduction"
        :key="index"
        v-show="item.type == 10 && item.blockName == '拼团规则'"
      >
        <h3 class="f28 bold">{{item.blockName}}</h3>

        <div v-if="item.blockContent" v-html="item.blockContent" class="blockContent"></div>
      </div>
    </div>
    <div class="top">
      <img src="/images/home/teamTitle.png" align="middle" />
    </div>
    <div class="shadow" v-if="shadow" @click="shadow = false">
      <img src="/images/home/teamBG.png" />
      <div class="dore">
        <p>点击右上角</p>
        <p>邀请闺蜜来拼团吧~</p>
      </div>
    </div>
    <van-popup
      v-model="suweCodeFlag"
      closeable
      close-icon-position="top-left"
      :style="{ height: '344px',width:'315px',borderRadius:'5px'}"
    >
      <div style="text-align: right;color:#BABBBC;padding:20px">
        <span>稍后再说</span>
        <img style="width:10px;height:10px" src="/images/home/back-icon.png" alt @click="tobag()" />
      </div>
    </van-popup>
    <van-popup
      v-model="weCodeFlag"
      closeable
      close-icon-position="top-left"
      :style="{ height: '344px',width:'315px',borderRadius:'5px',backgroundColor: '#DEF2F2'}"
    >
      <div style="text-align: center;color:#BABBBC;padding:20px 60px">
        <span class="code-title">长按下方二维码添加客服锁定获取礼品资格</span>
      </div>
      <div style="text-align: center;color:#BABBBC;">
        <img style="width:117px;height:117px" :src="weAcount.wechatCode" alt />
      </div>
      <div class="code-dis">
        或直接添加微信号
        <span>{{weAcount.wechatId}}</span>
      </div>
      <div class="code-button" style="margin-top:50px" @click="weCodeFlag=false">
        <span>我已添加</span>
      </div>
    </van-popup>
    <van-popup
      v-model="weCodeFlagPay"
      closeable
      close-icon-position="top-left"
      :style="{ height: '500px',width:'315px',borderRadius:'5px',backgroundColor: '#DEF2F2'}"
    >
      <div class="title-dig-cion" @click="weCodeFlagPay=false">
        稍后再说
        <img style="width:6px;height:10px;margin:0 10px" src="/images/growth/back-icon.png" alt />
      </div>
      <div class="title-dig">参团成功</div>
      <img src="/images/growth/one-two-three.png" alt style="width:315px;height:102px" />
      <div style="text-align: center;color:#BABBBC;padding:10px 60px">
        <span class="code-title">长按下方二维码添加客服锁定获取礼品资格</span>
      </div>
      <div style="text-align: center;color:#BABBBC;">
        <img style="width:117px;height:117px" :src="weAcount.wechatCode" alt />
      </div>
      <div class="code-dis">
        或直接添加微信号
        <span>{{weAcount.wechatId}}</span>
      </div>
      <div class="code-button" @click="weCodeFlagPay=false">
        <span>我已添加</span>
      </div>
    </van-popup>
  </section>
</template>

<script>
import homeApi from "@/axios/home";
import CountDown from "vue2-countdown";
import { setTimeout, setInterval, clearInterval } from "timers";
import publicObj from "@/assets/js/public";
import wxShare from "@/assets/js/wx.share";
import zhugeObj from "@/assets/js/track";
import { Dialog, Toast } from "vant";
export default {
  name: "teamDetail",
  components: { CountDown },
  data() {
    return {
      active: false,
      weCodeFlag: false,
      weCodeFlagPay: false,
      suweCodeFlag: false,
      code: "",
      detail: {
        curingServiceGoodsBo: {}
      },
      endTime: "",
      shadow: false,
      weAcount: {},
      getGift: {
        awardName: false
      },
      showKaituanFlag: false,
      customerIds: [],
      groupRecordId: "",
      interVal: "",
      serviceIntroduction: [],
      showCantuan: true,
      message: "~快快发起新的拼团吧~",
      showKaituan: true,
    };
  },
  watch: {
    weCodeFlagPay(){

    }
  },
  computed: {
    shareBtnText() {
      if (!this.$store.state.token) {
        return "帮他邀请好友";
      } else {
        if (this.customerIds.indexOf(this.$store.state.customerId) == -1) {
          return "帮他邀请好友";
        } else {
          return "邀请好友参团";
        }
      }
    },
    isInCustomer() {
      if (this.customerIds.indexOf(this.$store.state.customerId) == -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    this.code = this.$route.query.orderCode;
    let source = this.$route.query.source||'';
    this.groupRecordId = this.$route.query.groupRecordId;
    this.from = this.$route.query.from;
    if (this.code) {
      this.getDetail();
    }
    if (this.groupRecordId) {
      this.getDetailById();
    }
    if (this.from) {
      this.weCodeFlagPay = true;
      zhugeObj.track({
        title: "拼团详情页-支付完成加客服层-曝光"
      });
      setTimeout(()=>{
        if (this.code) {
          this.getDetail();
        }
        if (this.groupRecordId) {
          this.getDetailById();
        }
      },200)
    }
    zhugeObj.track({
      title: "拼团详情页-曝光",
      content: {
        'source': source
      }
    });

  },
  mounted() {},
  methods: {
    addKefyuWechat(){
      this.weCodeFlag=true
      zhugeObj.track({
        title: "拼团详情页-加客服微信-点击",
      });
    },
    getWecode() {
      homeApi
        .getWeCode({
          activiteId: this.detail.groupActivityId
        })
        .then(res => {
          this.weAcount = res;
          console.log(32323, res);
        });
    },
    toSendBag() {
      zhugeObj.track({
        title: "拼团详情-去养护-点击"
      });
      homeApi
        .groupHisActivity({
          groupActivityId: this.detail.groupActivityId
        })
        .then(res => {
          if (!res.awardName) {
            Dialog.confirm({
              message: "看起来你还没有选礼品，再等等好东西可就没有了",
              confirmButtonText: "这就去选",
              cancelButtonText: "再等等"
            })
              .then(() => {
                this.toGetGrowthShare();
              })
              .catch(() => {
                // on cancel
              });
          } else {
            this.$router.push({
              name: "quick"
            });
          }
        });
    },
    toGetGrowthShare() {
      zhugeObj.track({
        title: "拼团详情-选礼品-点击"
      });
      this.$router.push({
        name: "getGrowthShareDetail",
        query: {
          groupActivityId: this.detail.groupActivityId,
          groupActivityRecordId: this.detail.groupRecordId
        }
      });
    },
    lookMore() {
      zhugeObj.track({
        title: "拼团详情-查看更多活动"
      });
      this.$router.replace({ name: "homeIndex" });
    },
    lookOrder() {
      zhugeObj.track({
        title: "拼团详情-查看优惠券-点击"
      });
      this.$router.push({ name: "couponList" });
    },
    shadowTrue() {
      this.shadow = true;
      zhugeObj.track({
        title: "拼团详情-邀请好友参团-点击",
        content: {
          邀请好友参团: "邀请好友参团"
        }
      });
    },
    toService() {
      this.$router.push({
        name: "serviceDetail",
        query: { serviceId: this.detail.curingServiceGoodsBo.id }
      });
    },
    countDownE_cb() {
      if (this.code) {
        this.getDetail();
      }

      if (this.groupRecordId) {
        this.getDetailById();
      }
    },
    startTeam() {
      zhugeObj.track({
        title: "拼团详情-立即开团",
        content: {
          立即开团: "立即开团"
        }
      });
      if (!this.showKaituan) {
        Dialog.confirm({
          message: "看来你已经是其它团中的一员",
          confirmButtonText: "查看我参加的团",
          cancelButtonText: "我知道了"
        })
          .then(() => {
            homeApi
              .groupHisActivity({
                groupActivityId: this.detail.groupActivityId
              })
              .then(res => {
                if (!res) {
                  consolel.error("error");
                } else {
                  this.$router.push({
                    name: "teamDetail",
                    query: {
                      groupRecordId: res.groupActivityRecordId,
                      orderCode: res.orderCode
                    }
                  });
                  this.$router.go(0);
                }
              });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.addShopCart(this.detail.curingServiceId)
        // this.$router.push({
        //   name: "homeBag",
        //   query: {
        //     curingServiceId: this.detail.curingServiceId,
        //     buyQuantity: 1,
        //     isTeam: 1
        //   }
        // });
      }
    },
    addShopCart(curingServiceId,groupRecordId){
      let paramsActive = {
              remarks : '',
              action : 'normal',
              categoryRemark : '[{"id":3,"count":0},{"id":4,"count":0},{"id":5,"count":0},{"id":6,"count":0},{"id":87,"count":1}]',

          };
          
      paramsActive.curingServiceId = curingServiceId;
      paramsActive.buyQuantity = 1;
      paramsActive.groupRecordId = groupRecordId;
      homeApi.submitCart(paramsActive).then((res)=>{
          this.$router.push({name:'pay',query:{id:res.orderCode,type:'active',isTeam:'1'}})
        // this.$router.push({name:'pay',query:{id:res.orderCode,type:'active',isTeam:true}})
        
      }).catch((res)=>{
          if(res.code == 10086){
              Toast(res.message);
              return
          }
      })
    },
    submit() {
      let params1 = {
        action: "normal"
      };
      params1.curingServiceId = this.detail.curingServiceId;
      params1.buyQuantity = 1;
      params1.groupRecordId = this.detail.groupRecordId;

      zhugeObj.track({
        title: "拼团详情-立即参团",
        content: {
          立即参团: "立即参团"
        }
      });

      homeApi
        .getShoppingCart(params1)
        .then(res => {
          if (localStorage.getItem("token")) {
            // this.$router.push({
            //   name: "homeBag",
            //   query: {
            //     curingServiceId: this.detail.curingServiceId,
            //     buyQuantity: 1,
            //     teamId: this.detail.groupRecordId
            //   }
            // });
            this.addShopCart(this.detail.curingServiceId,this.detail.groupRecordId)
          }
        })
        .catch(res => {
          if (res.code == 10088) {
            Dialog.confirm({
              message: "看来你已经是其它团中的一员",
              confirmButtonText: "查看我参加的团",
              cancelButtonText: "我知道了"
            })
              .then(() => {
                homeApi
                  .groupHisActivity({
                    groupActivityId: this.detail.groupActivityId
                  })
                  .then(res => {
                    if (!res) {
                      consolel.error("error");
                    } else {
                      this.$router.push({
                        name: "teamDetail",
                        query: {
                          groupRecordId: res.groupActivityRecordId,
                          orderCode: res.orderCode
                        }
                      });
                      this.$router.go(0);
                    }
                  });
              })
              .catch(() => {
                // on cancel
              });
            console.log(444444);
          }
          if (res.code == "110001") {
            Dialog.confirm({
              message:
                "本团仅限新用户参加，你已经是老朋友了，不如试试发起同样的一个新团",
              confirmButtonText: "发起新团",
              cancelButtonText: "先不用了"
            })
              .then(() => {
                this.$router.push({
                  name: "serviceDetail",
                  query: { serviceId: this.detail.curingServiceGoodsBo.id }
                });
              })
              .catch(() => {
                // on cancel
              });
          }
        });
    },
    formatImgUrl(url, width, height, m_fill) {
      // console.log(url)
      let surl = url;
      if (url) {
        url = url.replace(
          "h_{height},w_{width}",
          "h_" + height + ",w_" + width + ""
        );
        // url = url.replace(',jpg', ",webp");
        if (url != surl) {
          url += ",q_80";
        }

        if (m_fill) {
          // console.log(m_fill)
          url = url.replace("m_lfit", "m_fill");
        }
      }
      // console.log(url)
      return url;
    },
    setShare() {
      setTimeout(() => {
        // console.log(window.location.href)
        let shareBody = {
          desc: "10位朋友已读",
          title: "香奈儿免费送！！快上车！！",
          link:
            window.location.href.split("?")[0] +
            "?groupRecordId=" +
            this.detail.groupRecordId
        };

        shareBody.imgUrl = this.formatImgUrl(
          'https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG214.jpeg',
          160,
          160,
          true
        );

        wxShare(shareBody).then(() => {});
      }, 1000);
    },
    requeError(status) {
      if (status == 40 || status == 90) {
        Dialog.confirm({
          message: status == 40 ? "此团已失效" : "此团已取消"
        })
          .then(() => {
            this.$router.push({
              name: "homeIndex"
            });
          })
          .catch(() => {
            this.$router.push({
              name: "homeIndex"
            });
          });
      }
    },
    getDetail() {
      let _this = this;
      // this.interVal = setInterval(() => {
      homeApi.activityByOrderCode(this.code).then(res => {
        //少一个是否有信息的验证
        if (res) {
          // clearInterval(this.interVal);
          this.detail = res;
          if (
            this.detail.groupRecordStatus == 40 ||
            this.detail.groupRecordStatus == 90
          ) {
            this.requeError(this.detail.groupRecordStatus);
            return;
          }
          if (this.detail.groupRecordStatus == 20) {
            let time = new Date().getTime();
            let times = time + this.detail.countDownExpire;
            this.endTime = times;
            this.teamVerify(this.detail.groupRecordId);
          }

          if (this.detail.detailBOList) {
            this.detail.detailBOList.forEach((item, index) => {
              this.customerIds.push(item.customerId + "");
            });
          }

          if (this.detail.differMemberNum < 0) {
            this.detail.differMemberNum = 0;
          }

          if (
            this.detail.groupRecordStatus == 30 &&
            this.customerIds.indexOf(this.$store.state.customerId) == -1
          ) {
            this.teamOpenVerify(this.detail.curingServiceId);
          }

          this.serviceIntroduction = res.curingServiceContentBoList;

          this.setShare();
          setTimeout(() => {
            this.active = true;
          }, 100);
          this.getHisGift();
          this.getWecode();
        }
      });
      // }, 500);
    },
    getHisGift() {
      let activityId = this.detail.groupActivityId;
      homeApi.groupHisActivity({ groupActivityId: activityId }).then(res => {
        this.getGift = res;
      });
    },
    getDetailById() {
      homeApi.activityById(this.groupRecordId).then(res => {
        //少一个是否有信息的验证
        if (res) {
          this.detail = res;
          if (
            this.detail.groupRecordStatus == 40 ||
            this.detail.groupRecordStatus == 90
          ) {
            this.requeError(this.detail.groupRecordStatus);
            return;
          }
          if (this.detail.groupRecordStatus == 20) {
            let time = new Date().getTime();
            let times = time + this.detail.countDownExpire;
            this.endTime = times;
            this.teamVerify(this.detail.groupRecordId);
          }

          if (this.detail.detailBOList) {
            this.detail.detailBOList.forEach((item, index) => {
              this.customerIds.push(item.customerId + "");
            });
          }

          if (this.detail.differMemberNum < 0) {
            this.detail.differMemberNum = 0;
          }

          if (
            this.detail.groupRecordStatus == 30 &&
            this.customerIds.indexOf(this.$store.state.customerId) == -1
          ) {
            this.teamOpenVerify(this.detail.curingServiceId);
          }

          this.serviceIntroduction = res.curingServiceContentBoList;
          this.setShare();
          setTimeout(() => {
            this.active = true;
          }, 100);
          this.getHisGift();
          this.getWecode();
        }
      });
    },
    teamOpenVerify(cid) {
      if (!this.$store.state.token) {
        return;
      }
      homeApi
        .teamOpenVerify(cid)
        .then(res => {})
        .catch(data => {
          if (data.code == 10088) {
            this.message = data.message;
            this.showKaituan = false;
          }
        });
    },
    teamVerify(id) {
      if (!this.$store.state.token) {
        return;
      }
      homeApi
        .teamVerify(id)
        .then(res => {
          this.showKaituanFlag = true;
        })
        .catch(data => {
          if (data.code == 110001) {
          } else if (data.code == 10086) {
            this.showKaituanFlag = false;
            this.message = "";
          } else {
            this.message = data.message;
            this.showKaituanFlag = true;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.customerName {
  font-size: 22px;
  font-weight: 500;
  margin-top: 20px;
  overflow: hidden;
  max-width: 280px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.callFriend {
  background: #fff !important;
  color: #333333 !important;
  border: 1px solid #979797;
  overflow: hidden;
}
.newTeam {
  color: #6aa0a4;
  font-size: 28px;
  margin-top: 64px;
}
.rule_content {
  padding-top: 40px;
}
.rule_content1 {
  padding: 40px;
}
.countDown {
  position: relative;
  // top:1px;
}
.shadow {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.8;
  width: 100%;
  height: 100%;
  z-index: 9999;
  img {
    width: 680px;
    position: absolute;
    top: 28px;
    right: 20px;
    z-index: 5;
  }
  .dore {
    position: absolute;
    top: 300px;
    text-align: center;
    font-size: 26px;
    width: 100%;
    z-index: 10;
    font-weight: 500;
    color: #fff;
    line-height: 35px;
  }
}
.serviceDetail {
  overflow: hidden !important;

  position: relative;
}
.active {
  // transition: all ease 1s;
  transform: scale(0.5) !important;
}
.suc {
  width: 450px;
  position: absolute;
  right: -96px;
  top: 155px;
  transform: scale(1);
  transition: all cubic-bezier(0.62, 0.02, 1, 0.79) 0.3s;
}
.fal {
  width: 450px;
  position: absolute;
  right: -96px;
  top: 155px;
  transform: scale(1);
  transition: all cubic-bezier(0.62, 0.02, 1, 0.79) 0.3s;
}
.mybtn {
  width: 400px;
  height: 64px !important;
  line-height: 64px !important;
}
.shareButton {
  width: 400px;
  height: 64px !important;
  font-size: 33px;
  padding: 0 10px;
  line-height: 64px !important;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 36px;
  color: #333333;
  overflow: hidden;
}
.mt64 {
  margin-top: 36px !important;
}
.mt16 {
  margin-top: 36px !important;
}
.user_img {
  display: flex;
  justify-content: center;
  margin: 64px 0;
  img {
    width: 130px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 4px solid #6aa0a4;
  }
  .wait_user {
    width: 130px;
    border-radius: 50%;
    height: 130px;
    background: rgba(240, 246, 246, 1);
    border: 2px dashed rgba(106, 160, 164, 1);
    font-size: 80px;
    line-height: 130px;
    color: rgba(106, 160, 164, 1);
    font-weight: 300;
    display: flex;
    justify-content: center;
  }
  .team_header {
    position: relative;
    .title {
      width: 64px;
      height: 28px;
      font-size: 18px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      background-color: #6aa0a4;
      line-height: 30px;
      position: absolute;
      bottom: 40px;
      left: 50%;
      margin-left: -32px;
    }
  }
}
.time {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.content_time {
  font-size: 24px !important;
  display: flex;

  & > span {
    line-height: 33px !important;
  }
}
.teamDetail_content {
  position: relative;
  padding: 80px 0;
  text-align: center;

  h3 {
    font-size: 44px;
    font-weight: 500;
    span {
      color: #66a2a6;
      margin: 0px 15px;
    }
  }
}
.top {
  height: 154px;
  background: #66a2a6;
  display: flex;
  position: relative;
  img {
    position: absolute;
    bottom: 28px;
    left: 50%;
    margin-left: -327px;
    width: 654px;
    height: 102px;
  }
}
.goodsDetail {
  padding: 48px 32px;
  display: flex;

  img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    flex-shrink: 0;
  }
  div {
    .name {
      font-weight: 500;
      font-size: 28px;
      color: #333;
      line-height: 40px;
      margin-left: 32px;
    }
    .dero {
      font-size: 24px;
      color: #999999;
      font-weight: 400;
      line-height: 36px;
      margin-top: 8px;
      margin-left: 32px;
    }
    .price {
      margin-top: 13px;
      color: #f24949;
      font-size: 28px;
      font-weight: 500;
      line-height: 40px;
      margin-left: 32px;
    }
  }
}

.blockContent {
  font-size: 25px !important;
}

.contentItem {
  line-height: 40px;
  h3 {
    margin-bottom: 40px;
    line-height: 40px;
    position: relative;
    &::after {
      content: "";
      width: 8px;
      height: 24px;
      background: $primary-color;
      position: absolute;
      left: -12px;
      top: 6px;
    }
  }
}
.van-collapse-item {
  img {
    width: 100%;
  }
}
.van-hairline--top::after {
  /*border-top-width:0;*/
  border-color: $border-color;
}
.van-hairline--top-bottom::after,
.van-hairline--top-bottom::after {
  border-width: 0;
}
.pdb {
  padding-bottom: 150px;
}
.code-title {
  width: 176px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
.code-dis {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(63, 63, 63, 0.85);
  text-align: center;
  color: #3f3f3f;
  padding-top: 30px;
  span {
    color: #6ddede;
  }
}
.code-button {
  width: 100%;
  height: 72px;
  margin-top: 50px;
  text-align: center;
  span {
    font-size: 32px;
    padding: 10px 150px;
    border-radius: 42px;
    border: 1px solid #141817;
  }
}
.title-dig {
  width: 100%;
  text-align: center;
  height: 70px;
  padding-top: 20px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #6ddede;
  background-color: #ffffff;
  line-height: 33px;
}
.title-dig-cion {
  width: 100%;
  height: 50px;
  text-align: right;
  padding: 20px 0px 0 0;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #babbbc;
  background-color: #ffffff;
  line-height: 50px;
}
.title-dis {
  width: 100%;
  text-align: center;
  height: 160px;
  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #666666;
  line-height: 160px;
}
.pic-body {
  width: calc(100% - 124px);
  background: #ffffff;
  margin: 0 40px;
  padding: 30px 0;
  border: 24px solid #def2f2;
}
.utoon-dis {
  text-align: center;
  width: 100%;
  margin-top: 50px;
}
</style>
<style>
.flip-clock__slot {
  display: none !important;
}
</style>
